import { useState, type FormEvent } from "react";
import { Link } from "react-router";
import { Button } from "../../components/Button";
import { Field, inputShell } from "../../components/Field";
import { ScreenHeader } from "../../components/ScreenHeader";

interface AdminLoginScreenProps {
  busy: boolean;
  error: string | null;
  onSubmit: (email: string, password: string) => void;
}

/** Admin sign-in with email and password (replaces the mock's shared passphrases). */
export function AdminLoginScreen({ busy, error, onSubmit }: AdminLoginScreenProps) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const submit = (event: FormEvent) => {
    event.preventDefault();
    if (email.trim() && password) onSubmit(email.trim(), password);
  };

  return (
    <form onSubmit={submit} className="max-w-[440px]">
      <ScreenHeader
        kicker="Staff"
        title="Admin sign-in"
        sub="For the gig readiness and Access to Finance teams. Use your company email."
      />
      <Field label="Email" htmlFor="admin-email">
        <input
          id="admin-email"
          type="email"
          autoComplete="username"
          className={inputShell}
          value={email}
          onChange={(event) => setEmail(event.target.value)}
        />
      </Field>
      <Field label="Password" htmlFor="admin-password">
        <input
          id="admin-password"
          type="password"
          autoComplete="current-password"
          className={inputShell}
          value={password}
          onChange={(event) => setPassword(event.target.value)}
        />
      </Field>
      {error ? (
        <p role="alert" className="mb-3 text-[13.5px] text-negative">
          {error}
        </p>
      ) : null}
      <Button type="submit" disabled={busy || !email.trim() || !password}>
        {busy ? "Signing in..." : "Sign in →"}
      </Button>
      <p className="mt-5 text-[13.5px]">
        <Link to="/admin/forgot-password" className="font-semibold text-accent underline">
          Forgot password?
        </Link>
      </p>
    </form>
  );
}
